import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'vant/lib/index.css'
import './utils/vantui'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//import 'amfe-flexible/index.js'
Vue.config.productionTip = false
// import VConsole from 'vconsole';
// let vConsole = new VConsole();
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
